import { Component, OnInit } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpMasterModel } from '../../model'
// import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { Injectable } from '@angular/core';
import { Router } from "@angular/router"
import * as $ from 'jquery';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-ssstatementlog',
    template: require('./ssstatementlog.component.html'),
    viewProviders: [ApiService]
})
// @Injectable({
//   providedIn: 'root',
// })
export class SSStatementlogComponent implements OnInit {
    EmpData: EmpMasterModel = new EmpMasterModel();
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    private rowData;
    EmpCountDetails: any;
    api: any;
    stateList: any = [];
    headQuarterList: any = [];
    ManagerList: any
    imagePath: any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token: any;
    Selfi_Image: any;
    tabdata: any;
    stmt: any;
    empStockistData: any;




    Emp_Form = new FormGroup({

        stockist: new FormControl('', [Validators.required]),

    });



    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient, private modalService: NgbModal) {
        this.apiService = apiService;
        var self = this;


    }


    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        // $('#filter-option').trigger('click');
        // this.getHeadQuarterList();
        // this.getManagerDetails();
        this.EmpData.status = -1;
        this.EmpData.stateId = 0;
        this.EmpData.HQ = 0;
        // this.EmpData.ManagerID = 0;
        var parent = this;
        // this.getEmployee();
        this.getStockistNameDetails();
        this.getSSSlog_Report();
        this.columnDefs = [
            { headerName: 'Stockist name', field: 'Stockist_name', width: 450, filter: 'agTextColumnFilter' },

            { headerName: 'Month', field: 'Month', width: 400, filter: 'agTextColumnFilter' },

            {
                headerName: 'Action', field: 'Action', width: 202,
                cellRenderer: function (params) {
                    // console.log("Dataaaa",params.data.Uploaded_Doc)
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `<span><input type="checkbox" class="acceptBtn" ${params.value == 1 ? 'checked' : ''} >locked</span>`;
                    // var content = 'content';
                    var acpButton = eDiv.querySelectorAll('.acceptBtn')[0];
                    acpButton.addEventListener('click', function () {
                        // alert("data locked successfully")

                        // this.openmodal()
                        // parent.imagePath = params.data.Uploaded_Doc;
                    });

                    return eDiv;
                }
            },
        ];
        //     this.tabdata=[{"Stockist_name":12123,
        // "File_name":126,
        // "Date":"tttt"
        // }]
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }


    onCellClicked(e) {
        if (e.column.colId == "Action") {
            if (e.value == 0) { this.stmt[e.rowIndex].Action = 1; }
            else if (e.value == 1) {
                this.stmt[e.rowIndex].Action = 0;
            }
            this.rowData = this.stmt
            this.api.refreshCells();
            console.log(e)
            var data = e.data
            data.UserId = this.token.id 
            this.apiService.ssslog(e.data).subscribe((res: any) => {
                console.log(res)
            })
        }
    }
    getSSSlog_Report() {
        this.apiService.SSSlog_Report().subscribe((res: any) => {
            this.stmt = res
        })
    }

    filter() {
        this.Emp_Form.value
        console.log(this.Emp_Form.value.stockist)
        // this.getSSreport(this.Emp_Form.value)

    }

    getStockistNameDetails() {
        this.apiService.getStockistNameDetails().subscribe((res: any) => {
            this.empStockistData = res.data;
            console.log('stockistName', this.empStockistData)
        })
    }
    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'employeemaster' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    uploadImage(uploadImage: any) {
        throw new Error('Function not implemented.');
    }

    viewCustomerDetails(data: any) {
        throw new Error('Function not implemented.');
    }


    imageURL(Uploaded_Doc: any) {
        throw new Error('Function not implemented.');
    }
}
